import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import componentStyles from './pc-alert.css.lit';

/**
 * The PcAlert component
 * @element pc-alert
 * @slot default -- alert message text
 */
@customElement('pc-alert')
export class PcAlert extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="pc-alert" role="alert" aria-labelledby="alert-message">
        <div class="pc-alert--icon" id="alert-message">
          <pc-icon name="alert" size="xl" is-fixed></pc-icon>
        </div>
        <div class="pc-alert--message" id="alert-message">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
